<template>
  <div>
    <DetailsFlow overview="Product Keys" :detail="detailName" />
    <ProductKeysOverview
      v-if="showCompanyDetails && !showCompanySubDetails && showUserDetails"
    />
    <CompanyDeatils v-if="!showCompanyDetails && !showCompanySubDetails" />
    <SubscriptionDetails v-if="showCompanySubDetails" />
    <UserSubDetails v-if="!showUserDetails" />
    <UserDetails v-if="!showUserDetails" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DetailsFlow from "@/components/DetailsFlow.vue";
import ProductKeysOverview from "@/components/ProductKeysOverview.vue";
import CompanyDeatils from "@/components/CompanyDeatils.vue";
import SubscriptionDetails from "@/components/SubscriptionDetails.vue";
import UserDetails from "@/components/UserDetails.vue";
import UserSubDetails from "@/components/UserSubDetails.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default defineComponent({
  name: "ProductKeysView",
  components: {
    DetailsFlow,
    ProductKeysOverview,
    CompanyDeatils,
    SubscriptionDetails,
    UserDetails,
    UserSubDetails,
  },
  computed: {
    ...mapGetters([
      "getUserData",
      "getCompanyData",
      "getSubscriptionData",
      "getCurrentUser",
    ]),
    showCompanyDetails(): any {
      return _.isEmpty(this.getCompanyData);
    },
    showCompanySubDetails(): boolean {
      return !_.isEmpty(this.getSubscriptionData);
    },
    showUserDetails(): any {
      return _.isEmpty(this.getUserData);
    },
    currentUser(): any {
      return _.isEmpty(this.getCurrentUser);
    },
    detailName(): string {
      var detailsName = !_.isEmpty(this.getUserData) ? "User" : "";
      detailsName = !_.isEmpty(this.getCompanyData) ? "Company" : detailsName;
      return detailsName;
    },
  },
});
</script>
